import axios from "axios";
import IMask from 'imask';

let applicationPaymentForm = document.getElementById("application_payment_form");
let applicationPaymentFormRemaining = document.getElementById("application_payment_form_2");

if (applicationPaymentForm) {

    let cc_number_elm = document.getElementById('frmCCNum');
    let cc_number_mask = IMask(cc_number_elm, {
        mask: '0000 0000 0000 0000'
    });

    let latestBIN = null;

    cc_number_elm.oninput = function() {

        let cardDigits = this.value.replace(/\s/g,'');
        
        // Taksit Seçeneklerini Görüntüle
        if (cardDigits.length >= 6) {

            let currentBIN = cardDigits.substr(0, 6);

            if (latestBIN != currentBIN) {

                latestBIN = currentBIN;
                document.querySelector('#send').setAttribute('disabled', 'disabled');
                document.querySelector('#send').classList.add('btn--loading');
                clearInstallmentOptions();

                axios.post('/odeme/bin', {
                    bin: cardDigits.toString().substr(0, 6),
                    id: document.getElementById('transaction_id').value
                }).then(function (response) {

                    let data = response.data;

                    if (data) {
                        displayInstallmentOptions(data.details, data.details_remaining, false);
                        document.querySelector('#send').classList.remove('btn--loading');
                        document.querySelector('#send').removeAttribute('disabled');
                    }

                }).catch(function (error) {
                    console.error('Hata', error);
                    latestBIN = null;
                    clearInstallmentOptions();
                });
                
            }

        } else {
            clearInstallmentOptions();
        }

    }

    let currentYear = (new Date()).getFullYear().toString();
    currentYear = parseInt(currentYear.substring(currentYear.length - 2));
    let cc_exp_elm = document.getElementById('frmCCExp');
    let cc_exp_mask = new IMask(cc_exp_elm, {
        mask: 'mm/yy',        
        blocks: {
        mm: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 12,
            maxLength: 2,
        },
        yy: {
            mask: IMask.MaskedRange,
            from: currentYear,
            to: 99,
            maxLength: 2
        }
        }

    });

}

if (applicationPaymentFormRemaining) {

    let cc_number_elm = document.getElementById('frmCCNum');
    let cc_number_mask = IMask(cc_number_elm, {
        mask: '0000 0000 0000 0000'
    });

    let latestBIN = null;

    cc_number_elm.oninput = function() {

        let cardDigits = this.value.replace(/\s/g,'');
        
        // Taksit Seçeneklerini Görüntüle
        if (cardDigits.length >= 6) {

            let currentBIN = cardDigits.substr(0, 6);

            if (latestBIN != currentBIN) {

                latestBIN = currentBIN;
                document.querySelector('#send').setAttribute('disabled', 'disabled');
                document.querySelector('#send').classList.add('btn--loading');
                clearInstallmentOptions();

                axios.post('/odeme/bin', {
                    bin: cardDigits.toString().substr(0, 6),
                    id: document.getElementById('transaction_id').value
                }).then(function (response) {

                    let data = response.data;

                    if (data) {
                        console.log(data)
                        displayInstallmentOptions(data.details, data.details_remaining, true);
                        document.querySelector('#send').classList.remove('btn--loading');
                        document.querySelector('#send').removeAttribute('disabled');
                    }

                }).catch(function (error) {
                    console.error('Hata', error);
                    latestBIN = null;
                    clearInstallmentOptions();
                });
                
            }

        } else {
            clearInstallmentOptions();
        }

    }

    let currentYear = (new Date()).getFullYear().toString();
    currentYear = parseInt(currentYear.substring(currentYear.length - 2));
    let cc_exp_elm = document.getElementById('frmCCExp');
    let cc_exp_mask = new IMask(cc_exp_elm, {
        mask: 'mm/yy',        
        blocks: {
        mm: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 12,
            maxLength: 2,
        },
        yy: {
            mask: IMask.MaskedRange,
            from: currentYear,
            to: 99,
            maxLength: 2
        }
        }

    });

}

function displayInstallmentOptions(details, details_remaining, remaining) {

    let installmentOptionsElm = document.getElementById('installment-options');
    let installmentsWrapperElm = document.getElementById('installments');
    
    if (installmentOptionsElm) {

        installmentOptionsElm.innerHTML = '';

        const installmentOptions = remaining ? details_remaining : details;
        console.log(installmentOptions);
        if (installmentOptions && installmentOptions.length) {

            installmentsWrapperElm.style.display = 'block';
            
            for (let i = 0; i < installmentOptions.length; i++) {

                let detail = installmentOptions[i];
                let option = document.createElement('div');
                option.className = 'py-2 border-b';
                
                let interestText = `<p class="fs-xs color-grey lh-xl">${detail.text.interest} banka komisyonu</p>`;

                option.innerHTML = `
                <label class="radio w-100">
                    <input type="radio" name="installment" value="${detail.installment}">
                    <div class="radio-control align-items-center">
                        <span class="radio-tick"></span>
                        <div class="radio-text d-flex justify-content-between align-items-center w-100">
                            <div>
                                <span class="fw-500">${detail.text.installment}</span>
                            </div>
                            <div class="text-right">
                                <div>
                                    <span class="fw-500 color-grey-1">${detail.text.monthly}</span><span class="fs-xs color-grey-3"> / ay</span>
                                </div>
                                <p class="fs-xs fw-500 color-grey-2">Toplam: ${detail.text.total}</p>
                                ${detail.interest > 0 ? interestText : ''}
                            </div>
                        </div>
                    </div>
                </label>`;

                installmentOptionsElm.appendChild(option);

            }

            installmentOptionsElm.querySelector('input[type="radio"]').checked = true;
            
        } else {
            installmentsWrapperElm.style.display = 'none';
        }

        
    }

}

function clearInstallmentOptions() {
    let installmentOptionsElm = document.getElementById('installment-options');
    let installmentsWrapperElm = document.getElementById('installments');

    if (installmentOptionsElm) {
        installmentOptionsElm.innerHTML = '';
    }
    
    if (installmentsWrapperElm) {
        installmentsWrapperElm.style.display = 'none';
    }

}